




import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceType} from "../../../../enums/type";

@Component({
    name: "ServiceTypeLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly type!: number;

    FreightServiceType = FreightServiceType;
}
